"use strict";

exports.__esModule = true;
exports["default"] = share;

var _socialSharing = require("../constants/social-sharing");

var _urijs = _interopRequireDefault(require("urijs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var WIDTH = 640;
var HEIGHT = 640;

var openShareDialog = function openShareDialog(url) {
  window.open(url, 'Share', "width=" + WIDTH + ",height=" + HEIGHT + ",toolbar=no,menubar=no,scrollbars=no,location=no,status=no");
};

var encodeUrlTwice = function encodeUrlTwice(href) {
  var uri = new _urijs["default"](href);
  uri.pathname(encodeURI(encodeURI(uri.pathname())));
  return uri.href();
};

var getUrl = function getUrl(socialNetwork, href) {
  switch (socialNetwork) {
    case _socialSharing.SOCIAL_SHARING_FACEBOOK:
      return "http://www.facebook.com/sharer/sharer.php?u=" + href;

    case _socialSharing.SOCIAL_SHARING_TWITTER:
      return "https://twitter.com/share?url=" + encodeUrlTwice(href);

    case _socialSharing.SOCIAL_SHARING_LINKED_IN:
      return "https://www.linkedin.com/shareArticle?mini=true&url=" + href;

    default:
      return;
  }
};

function share(type, path) {
  openShareDialog(getUrl(type, path));
}